import React from 'react';
import Column from '../Columns/Column';
import ColumnHeader from '../Columns/ColumnHeader';
import ColumnContents from '../Columns/ColumnContents';
import RGL, { WidthProvider } from "react-grid-layout";
import { useAttributeFormBuilder, useLayout } from '../../../../Hooks/Display/useComponentProperties';
import { findDraggedColumn } from '../utils';
import { useSelectedComponent } from '../../../../Hooks/Display/useComponents';

const ReactGridLayout = WidthProvider(RGL);

const SectionColumns = ({ section, draggedColumnId, onDropColumn, onDragColumn }) => {

    const [{ steps }, dispatch] = useAttributeFormBuilder();
    const selectedComponent = useSelectedComponent();
    const layout = useLayout()

    const handleLayoutChange = (columns) => {
        dispatch.resizeColumns(columns, section.id);
    };

    const handleDropColumn = (layout) => {
        onDropColumn(layout, section.id)
    }

    const handleDroppingItem = () => {
        const column = findDraggedColumn(layout, draggedColumnId);
        return {
            i: '__dropping-elem__',
            w: column ? column.w : selectedComponent.componentType === "Cards" ? 12 : 6,
            h: column ? column.h : 1,
        }
    }

    return (
        <ReactGridLayout
            className="layout"
            layout={section.columns}
            items={section.columns.length}
            useCSSTransforms={true}
            cols={12}
            margin={[15, 15]}
            droppingItem={handleDroppingItem()}
            containerPadding={[15, 15]}
            autoSize={true}
            rowHeight={100}
            resizeHandles={['s', 'e', 'w', 'n', 'sw', 'nw', 'se', 'ne']}
            draggableHandle=".droppable-element"
            draggableCancel='.non-draggable'
            isDroppable={true}
            onDrop={handleDropColumn}
            onLayoutChange={handleLayoutChange}
        >
            {section.columns.map((column) => (
                <div
                    key={column.i}
                    className="droppable-element"
                    dataId={column.i}
                    onDragColumn={onDragColumn}
                >
                    <ColumnHeader column={column} />
                    <ColumnContents column={column} />
                </div>
            ))}
        </ReactGridLayout>
    );
};

export default SectionColumns;
